module.exports = __webpack_public_path__ + "static/media/insulation_allImpact_60yd_y.3f5cf72c.csv";